import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: NetworkDomain.State = {
	session: {
		loaded: false,
		loading: false
	},
	allProductData: {
		loaded: false,
		loading: false
	}
};

const slice = createSlice({
	name: 'networkSlice',
	initialState: initialState,
	reducers: {
		startedLoadingAllProductData: (
			state: NetworkDomain.State,
			action: PayloadAction<NetworkDomain.State>
		) => ({
			...state,
			...action.payload
		}),
		allProductDataLoaded: (
			state: NetworkDomain.State,
			action: PayloadAction<NetworkDomain.State>
		) => {
			const { allProductData, session } = action.payload;

			state.allProductData = allProductData;
			state.allProductData.loaded = true;
			state.allProductData.loading = false;

			state.session = session;
			state.session.loaded = true;
			state.session.loading = false;
		}
	}
});

export const networkReducer = slice.reducer;
export const { startedLoadingAllProductData, allProductDataLoaded } =
	slice.actions;
